import React, { useContext, useEffect, useState, useRef } from "react";
import { Container, Row, Col, Alert, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { IconWallet } from "../../../assets/icons";
import { NumericFormat } from "react-number-format";
import { useForm } from "react-hook-form";
import ApiUserWithdrawal from "../../../core/api/api.userWithdrawal";
import ApiAccount from "../../../core/api/api.account";
import _ from "lodash";
import SplitNumber from "../../components/SplitNumber";
import ContextApp from "./../../../core/contexts/context.app";
import ApiUserWallet from "../../../core/api/api.userWallet";
import walletImage from "../../../assets/images/wallet-pana.svg";
import { isMobile } from "react-device-detect";
import { ToastContainer, toast } from "react-toastify";
import Refund from "../Refund/Index";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { tools } from "../../../core/utils/tools";
import "react-toastify/dist/ReactToastify.css";
import LoadingDottedButton from "../../components/LoadingDottedButton";

function WithdrawFromWallet() {
  const ctx = useContext(ContextApp);
  const navigate = useNavigate();
  const [liveData, setLiveData] = useState({ userTransactions: [] });
  const [loadingData, setLoadingData] = useState(false);
  const [accounts, setAccounts] = useState();
  const [newAccount, setNewAccount] = useState(null);

  /*** مدال افزودن حساب ******************** */
  const [showRefundModal, setShowRefundModal] = useState(false);

  let location = useLocation();
  const rialAmountRef = useRef(null);
  useEffect(() => {
    if (ctx.isAuth) {
      getData();
      getAccount();
    } else {
      let path = "/login";
      navigate(path, { prevPath: location.pathname });
    }
  }, [ctx.isAuth]);
  async function getData() {
    setLoadingData(true);
    try {
      // گرفتن کیف پول
      const response = await ApiUserWallet.getUserWallet();

      if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
        setLiveData(response.data);

        //let userInfo = ServiceStorage.getUserInfo();

        // if (userInfo != null) {
        //   userInfo.walletRiallBalance = response.data.riallBalance;
        //   userInfo.walletAvailableRiallBalance =
        //     response.data.useAvailableRiallBalance;
        //   //ویرایش اطلاعات کاربر
        //   ServiceStorage.setUserInfo(userInfo);
        //   ctx.setUserInfo(userInfo);
        // }
      }
    } catch (error) {
      setLoadingData(false);
    } finally {
      setLoadingData(false);
    }
  }

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm();

  const sweetAlertModal = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-outline-success mt-2",
    },
    buttonsStyling: false,
  });

  const onSubmit = async (data) => {
    try {
      data.rialAmount = data.rialAmount.split(" ").join("").split(",").join("");

      if (
        parseInt(liveData.useAvailableRiallBalance) == 0 ||
        parseInt(data.rialAmount) > parseInt(liveData.useAvailableRiallBalance)
      ) {
        toast.error("مبلغ وارد شده بیشتر از موجودی کیف پول شماست", {
          position: "top-right",
        });
        return;
      } else {
        const response = await ApiUserWithdrawal.createUserWithdrawal({
          rialAmount: parseInt(data.rialAmount),
          destinationAccountId: parseInt(data.accountId),
        });

        if (!_.isEmpty(response)) {
          const selecetdAccount =
            accounts.find((account) => account.value === data.accountId) ||
            newAccount;
          if (response.succeeded) {
            sweetAlertModal
              .fire({
                icon: "success",
                title: "  درخواست شما با موفقیت ثبت گردید.",
                showClass: {
                  popup: `
              animate__animated
              animate__fadeIn
              animate__faster`,
                },
                hideClass: {
                  popup: `
              animate__animated
              animate__fadeOut
              animate__faster`,
                },
                html: `<div class='border rounded-3 px-3 py-2 text-start fs-08'>مبلغ : ${tools.splitNumberForPrice(
                  data.rialAmount
                )}  تومان <br> ${
                  selecetdAccount.title
                }</div><div class='py-2 alert alert-info fs-08 text-start mb-0 mt-2'>حداکثر تا 72 ساعت پس از تایید سامانه ، مبلغ ${tools.splitNumberForPrice(
                  data.rialAmount
                )} تومان به حساب شما واریز خواهد شد</div>`,
                confirmButtonText: " بستن ",
              })
              .then(() => {
                navigate("/withdrow");
              });
          } else {
            toast.error(
              response.message || "مشکلی در ایجاد درخواست به وجود آمده است",
              { position: "top-right" }
            );
          }
        }
      }
    } catch (error) {}
  };
  async function getAccount() {
    try {
      // گرفتن لیست حساب ها
      const response = await ApiAccount.getAllAccountForUserId();

      if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
        setAccounts(response.data);
      }
    } catch (error) {}
  }

  const handleRefundModal = () => {
    setShowRefundModal(true);
  };

  useEffect(() => {
    // بعد از بسته شدن مدال تمرکز به فیلد منتقل شود
    setTimeout(() => {
      rialAmountRef.current?.focus();
      const length = rialAmountRef.current?.value.length;
      rialAmountRef.current?.setSelectionRange(length, length);
    }, 500);
  }, [showRefundModal]);

  useEffect(() => {
    if (newAccount) {
      setValue("accountId", newAccount.value);
    }
  }, [newAccount]);

  const handleFocus = () => {
    if (rialAmountRef.current) {
      rialAmountRef.current?.focus();
      const length = rialAmountRef.current?.value.length;
      rialAmountRef.current?.setSelectionRange(length, length);
    }
  };

  return (
    <Container fluid className=" min-height-page ">
      <Container className="px-0">
        <Refund
          showRefundModal={showRefundModal}
          setShowRefundModal={setShowRefundModal}
          onAddAccount={(newAccount) => {
            setNewAccount(newAccount); // ذخیره حساب جدید
            setShowRefundModal(false); // بستن مدال
            setValue("accountId", newAccount.value); //  انتخاب حساب جدید به‌طور خودکار
          }}
        />

        <div className="py-3">
          <div className=" shadow-sm rounded-3 p-3 bg-white">
            <Row className="">
              <Col xs="12" md="12" lg="7" xl="6">
                <form key={2} onSubmit={handleSubmit(onSubmit)}>
                  <div className="d-flex align-items-center justify-content-between  justify-content-lg-cenetr  border-bottom pb-3 mb-3">
                    <div>
                      <IconWallet fillColor="#444" /> موجودی کیف پول
                    </div>
                    <div className="fw-bold ps-lg-4">
                      {loadingData ? (
                        <Skeleton height="13px" width="60px"></Skeleton>
                      ) : liveData?.useAvailableRiallBalance == null ? (
                        " 0 تومان"
                      ) : (
                        <SplitNumber
                          number={liveData?.useAvailableRiallBalance + " تومان"}
                        />
                      )}
                    </div>
                  </div>
                  {loadingData ? (
                    <div>در حال دریافت اطلاعات ... </div>
                  ) : liveData?.useAvailableRiallBalance > 0 ? (
                    <>
                      <div className="text-dark fs-09 pt-2 pb-3 text-justify text-center ">
                        {accounts != null && accounts.length > 0 ? (
                          <>
                            <div className="fs-08">
                              {" "}
                              جهت برداشت از کیف پول، شماره حساب , مبلغ را وارد
                              نمایید.
                            </div>
                          </>
                        ) : (
                          <div>
                            جهت برداشت از کیف پول، شماره حساب , مبلغ را وارد
                            نمایید.
                          </div>
                        )}
                      </div>
                      <Row className="gx-lg-2">
                        <Col xs="12">
                          {accounts != null && accounts.length > 0 ? (
                            <>
                              <Form.Select
                                {...register("accountId", {
                                  required:
                                    "لطفا یکی از کارت ها را انتخاب نمایید",
                                })}
                                as="select"
                                name="accountId"
                                className="mb-2 rounded-2 d-inline-block text-center fs-normal"
                                style={{ height: "38px" }}
                              >
                                <option value=""> انتخاب شماره کارت </option>
                                {accounts.map((item, index) => (
                                  <option
                                    value={item.value}
                                    key={`opt_${index}`}
                                  >
                                    {item.title}
                                  </option>
                                ))}
                                {newAccount && (
                                  <option value={newAccount.value}>
                                    {newAccount.title}
                                  </option>
                                )}
                              </Form.Select>

                              {errors.accountId && (
                                <span className="text-danger">
                                  {errors.accountId.message}
                                </span>
                              )}
                            </>
                          ) : (
                            <Button
                              className="btn btn-primary w-100 rounded-2"
                              onClick={handleRefundModal}
                            >
                              افزودن شماره حساب
                            </Button>
                          )}
                        </Col>
                        {accounts != null && accounts.length > 0 ? (
                          <>
                            <Col xs="12">
                              <div className="form-control rounded-2 text-center mb-2 d-flex align-items-center">
                                <NumericFormat
                                  {...register("rialAmount", {
                                    required: "مبلغ را وارد نمایید!",
                                  })}
                                  className="border-0 btn-no-style text-center w-100 fs-normal"
                                  suffix=" تومان "
                                  decimalScale="0"
                                  thousandSeparator=","
                                  placeholder="مبلغ درخواستی"
                                  maxLength={20}
                                  onFocus={handleFocus}
                                  getInputRef={rialAmountRef}
                                  onValueChange={(values) => {
                                    const { value } = values;
                                    setValue("rialAmount", value, {
                                      shouldValidate: true,
                                    });
                                  }}
                                />
                              </div>
                              {errors.rialAmount && (
                                <span className="text-danger">
                                  {errors.rialAmount.message}
                                </span>
                              )}
                            </Col>
                            <Col xs="12" lg="6">
                              {!isSubmitting ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary w-100 rounded-2 fs-normal"
                                >
                                  برداشت از کیف پول
                                </button>
                              ) : (
                                <button
                                  disabled
                                  type="submit"
                                  className="btn btn-primary  w-100 rounded-2 fs-normal"
                                >
                                  <LoadingDottedButton btnText="برداشت از کیف پول" />
                                </button>
                              )}
                              {/* <Button
                                variant="primary"
                                className="w-100 rounded-2 fs-normal"
                                type="submit"
                                disabled={isSubmitting}
                              >
                                {isSubmitting && (
                                  <Spinner
                                    animation="border"
                                    variant="warning"
                                    size="sm"
                                  />
                                )}
                                برداشت از کیف پول
                              </Button> */}
                            </Col>
                            <Col xs="12" lg="6">
                              <Button
                                variant="outline-primary"
                                onClick={handleRefundModal}
                                className="rounded-2 mt-3 mt-lg-0 small-svg fs-normal w-100"
                              >
                                {/* <IconPlus fillColor="#f80248" /> */}
                                <span className="ms-1">
                                  افزودن شماره حساب جدید
                                </span>
                              </Button>
                            </Col>
                            <Col xs="12">
                              <div className="mt-2 mt-lg-3 fs-075 text-dark">
                                چنانچه تمایل دارید شماره کارت جدید اضافه کنید
                                برروی دکمه
                                <span
                                  className="text-danger cursor-pointer"
                                  onClick={handleRefundModal}
                                >
                                  {" "}
                                  «افزودن شماره حساب جدید»
                                </span>
                                کلیک نمایید.
                              </div>
                            </Col>
                          </>
                        ) : (
                          ""
                        )}
                      </Row>
                    </>
                  ) : (
                    <Alert variant="warning">
                      موجودی کیف پول شما 0 تومان می باشد و امکان برداشت وجه وجود
                      ندارد
                    </Alert>
                  )}
                </form>
              </Col>
              {isMobile ? (
                " "
              ) : (
                <Col md="6" lg="5" xl="4" className="mx-auto">
                  <img src={walletImage} alt="wallet" className="w-100" />
                </Col>
              )}
            </Row>
          </div>
        </div>
      </Container>
      {/* <ToastContainer position="top-right" rtl="true" /> */}
    </Container>
  );
}
export default WithdrawFromWallet;
